function getAlignXFlexValue(alignX) {
  if (alignX === 'start') {
    return 'flex-start';
  }
  if (alignX === 'end') {
    return 'flex-end';
  }
  return alignX;
}
function getAlignYFlexValue(alignY) {
  if (alignY === 'top') {
    return 'flex-start';
  }
  if (alignY === 'bottom') {
    return 'flex-end';
  }
  return alignY;
}
export function getJustifyContent(_ref) {
  var {
    direction,
    alignHorizontal,
    alignVertical
  } = _ref;
  if (direction !== undefined && ['horizontal', 'horizontal-reverse', 'row', 'row-reverse'].includes(direction)) {
    return getAlignXFlexValue(alignHorizontal);
  }
  if (alignVertical === 'baseline') {
    return;
  }
  return getAlignYFlexValue(alignVertical);
}
export function getAlignItems(_ref2) {
  var {
    direction,
    alignHorizontal,
    alignVertical
  } = _ref2;
  if (direction !== undefined && ['horizontal', 'horizontal-reverse', 'row', 'row-reverse'].includes(direction)) {
    if (alignVertical !== null && alignVertical !== void 0 && alignVertical.startsWith('space-')) {
      return;
    }
    return getAlignYFlexValue(alignVertical);
  }
  if (alignHorizontal !== null && alignHorizontal !== void 0 && alignHorizontal.startsWith('space-')) {
    return;
  }
  return getAlignXFlexValue(alignHorizontal);
}
var directionMap = {
  horizontal: 'row',
  vertical: 'column',
  'horizontal-reverse': 'row-reverse',
  'vertical-reverse': 'column-reverse',
  column: 'column',
  row: 'row',
  'row-reverse': 'row-reverse',
  'column-reverse': 'column-reverse'
};
export function getDirection(direction) {
  return directionMap[direction] || 'column';
}
//# sourceMappingURL=styleValueUtils.js.map